import {ICON_TYPES} from '../constants';

export const ClockIcon = (): JSX.Element => {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.5 0C6.40749 0.00632994 4.39045 0.782383 2.83333 2.18025V0H1.41667V3.64296C1.41704 3.9917 1.55575 4.32606 1.80235 4.57265C2.04894 4.81925 2.3833 4.95796 2.73204 4.95833H6.375V3.54167H3.45596C4.60719 2.37545 6.12766 1.64517 7.75758 1.47562C9.3875 1.30607 11.0257 1.70776 12.3923 2.61206C13.759 3.51636 14.7691 4.86715 15.2503 6.43364C15.7315 8.00012 15.6538 9.68508 15.0304 11.2006C14.4071 12.7162 13.2769 13.9682 11.8328 14.7429C10.3888 15.5176 8.72054 15.7668 7.11314 15.4479C5.50575 15.129 4.05895 14.2619 3.01996 12.9947C1.98097 11.7274 1.41426 10.1387 1.41667 8.5H0C0 10.1811 0.498516 11.8245 1.43251 13.2223C2.3665 14.6202 3.69402 15.7096 5.24719 16.353C6.80036 16.9963 8.50943 17.1646 10.1583 16.8367C11.8071 16.5087 13.3217 15.6992 14.5104 14.5104C15.6992 13.3217 16.5087 11.8071 16.8367 10.1583C17.1646 8.50943 16.9963 6.80036 16.353 5.24719C15.7096 3.69402 14.6202 2.3665 13.2223 1.43251C11.8245 0.498516 10.1811 0 8.5 0Z'
        fill='#43494F'
      />
      <path
        d='M7.79163 4.9585V8.79341L10.1242 11.126L11.1258 10.1244L9.20829 8.20691V4.9585H7.79163Z'
        fill='#43494F'
      />
    </svg>
  );
};

ClockIcon.iconType = ICON_TYPES.CLOCK;
